import React from 'react';
import { PriceString } from '@fourthwall/components';
import { isGiftCardGroup } from '../../utils/isGiftCardGroup';
import * as S from '../GiftCardTableCell/GiftCardTableCell.styled';
export const GiftCardUsageTableCell = ({ giftCard }) => {
    return (React.createElement("div", null,
        React.createElement(S.Title, null,
            React.createElement(PriceString, { ...giftCard.currentAmount }),
            " /",
            ' ',
            React.createElement(S.SecondaryTitle, null,
                React.createElement(PriceString, { ...giftCard.initialAmount }))),
        isGiftCardGroup(giftCard) && (React.createElement(S.Summary, null,
            giftCard.fullyUsedCardsCount,
            " of ",
            giftCard.codes.length,
            " used"))));
};
